import React from "react";
import { filter, toLower, size } from "lodash";
import { Flex } from "../../../components/Flex";
import { Paragraph, Title } from "../../../components/Text";
import { Content } from "../../../components/Layout";
import { formatDate } from "../../../utils";
import { CloseIcon } from "../../../icons/CloseIcon";
import { ExternalLinkIcon } from "../../../icons/ExternalLinkIcon";
import { Scrollbar } from "../../../components/Scrollbar";
import { Grid } from "../../../components/Grid";
import { Link } from "react-router-dom/cjs/react-router-dom.min";
import { Button } from "../../../components/Button";
import { DownloadIcon } from "../../../icons/DownloadIcon";


const SYSARCHS = {
    "AXP": "Alpha",
    "I64": "Integrity",
    "X86": "X86"
};

const swtypes = {
    e: {
        title: "Operating System ECO",
        byVersions: true
    },
    l: {
        title: "Layered Product"
    },
    o: {
        title: "Open-Source Product"
    }
};

const MasterKitList = ({ data={}, onClose, pathname, location, loading, downloadMasterKitList, isAdmin }) => {
    const { hash } = location;

    React.useEffect(() => {
        const anchor = hash.slice(1);
        if (anchor && loading == false) {
            const anchorEl = document.getElementById(anchor);
            if (anchorEl) {
                anchorEl.scrollIntoView({ block: "start" });
            }
        }
    }, [ hash, loading ]);


    const renderContent = (data={}) => {
        let overview = [<Title key={"overview-title"}>Table of contents</Title>], content = [];

        const renderKits = (swtype, byVersions=false) => {
            overview.push(<Title key={`overview-${swtype}`}>{swtypes[swtype].title} kits</Title>);
            let overviewRows = [];
            let products = data[swtype];
            let sysarchs = Object.keys(products).filter(sysarch => products[sysarch].length).sort();
            if (!sysarchs.length) {
                overview.push(<Paragraph key={`no-kits-${swtype}`}>No kits available.</Paragraph>)
            };
            sysarchs.map(sysarch => {
                if (!Object.keys(SYSARCHS).includes(sysarch.toUpperCase())) {
                    return;
                };
                let osVersions = byVersions ? new Set(products[sysarch].reduce((a, b) => a.concat(b.minos), [])) : [null];
                Array.from(osVersions).sort().forEach((version, idx) => {
                    let productsByVersion = filter(products[sysarch], product => version ? product.minos.includes(version) : product);
                    let anchor = toLower(sysarch) + (version ? toLower(version.replace(/[.-]/g, "")) : "") + swtype;
                    overviewRows.push(
                        <Link key={`${sysarch}-${version}`} to={{ hash: `#${anchor}`}}>
                            &#8226;&nbsp;&nbsp;{SYSARCHS[sysarch]}&nbsp;&nbsp;{version}
                        </Link>
                    );
                    content.push(<Flex key={`${swtype}-${sysarch}-${idx}-products`} margin={{ top: "2rem" }} direction="column" gap={{ bottom: 12 }}>
                        <Flex key={anchor} gap={{ right: 8 }}>
                            <Title id={`${toLower(sysarch)}${version ? toLower(version.replace(/[.-]/g, "")) : ""}${swtype}`}>Current {SYSARCHS[sysarch]} {version} {swtypes[swtype].title} kits</Title>
                            <Link to={`/packages?sysarch=${toLower(sysarch)}&minos=${toLower(version)}&swtype=${swtype}${isAdmin ? "&verified=1" : ""}`}><ExternalLinkIcon size={16} /></Link>
                        </Flex>
                        <Grid key={`grid-${swtype}`} count={4} gridTemplate="1fr 20% 10% 1fr">
                            {productsByVersion.reduce((a, product) => (
                                a.concat(
                                    [
                                        product.hasAccess
                                            ? <Link key={`${product.name}-${idx}`} to={{ pathname: `/packages/${product.key}`, state: { from: pathname } }}>{product.name}</Link>
                                            : <Paragraph key={`${product.name}-${idx}`}>{product.name}</Paragraph>,
                                        <Paragraph key={`${product.name}-${idx}-date`}>{product.releaseDate}</Paragraph>,
                                        <Paragraph key={`${product.name}-${idx}-reboot`}>{product.restartRequired}</Paragraph>,
                                        byVersions
                                            ? <Paragraph key={`${product.name}-${idx}-rating`}>{product.ecoRating}</Paragraph>
                                            :  <Paragraph key={`${product.name}-minos`}>{Array.isArray(product.minos) ? product.minos.join(", ") : product.minos}</Paragraph>
                                    ]
                                )
                            ), ["Kit Name", "Release Date", "Reboot", byVersions ? "Install Rating" : "Supported VSI Releases"]
                            )}
                        </Grid>
                    </Flex>);
                })
            });
            overview.push(<Flex key={`${swtype}-overview`} direction="column" padding={{ left: "24px" }} gap={{ bottom: 4 }}>
                {overviewRows}
            </Flex>);
        };

        filter(Object.keys(data), o => Object.keys(swtypes).includes(o)).sort().map(((swtype) => {
            renderKits(swtype, swtypes[swtype].byVersions);
        }));

        return overview.concat(content)
    };

    return(
        <Content background="#FFFFFF">
            <Flex width="100%" justify="space-between" margin={{ bottom: "24px"}}>
                <Title h4>VSI Master Kit list</Title>
                <CloseIcon onClick={onClose} />
            </Flex>
            <Scrollbar id="content-scrollbar" >
                <Flex id="master-kit-list" direction="column" gap={{ bottom: 12 }}>
                    <Paragraph>Last Update Date: {formatDate(Date.now(), "DD-MMM-YYYY")}</Paragraph>
                    {loading
                        ? Array(6).fill(null).map((item, idx) => <Paragraph key={`loading-row-${idx}`} isLoading width={idx < 3 ? "40%" : "80%"} lineHeight="22px"  />)
                        : renderContent(data)}
                </Flex>
            </Scrollbar>
            <Flex>
                <Button disabled={!size(data)} onClick={() => downloadMasterKitList()}>
                    <DownloadIcon size={20} />
                    Download
                </Button>
            </Flex>
            {/* <Button.BackToTop onClick={(e) => {
                e.preventDefault();
                document.getElementById("master-kit-list").scrollIntoView({ block: "start", behavior: "smooth" });
                history.replace({ hash: "" });
            }} /> */}
        </Content>
    )

};

export { MasterKitList }